import { TagCreateActions as TagCreateActions } from './tag-create.actions';
import { ReduxBaseReducer, IReduxBase } from '../../redux-base/redux.base.reducer';
import { ReflectiveInjector } from '@angular/core';
import { NgRxAction } from '../../action.interface';

export interface ICreateTag extends IReduxBase {
}

export function tagCreateReducer(state, {type, payload}: NgRxAction) {
  return ReduxBaseReducer.getConfig(ReflectiveInjector.resolveAndCreate(
    [TagCreateActions]).get(TagCreateActions), state, {type, payload});
}

